<template>
  <div class="_grid">
    <div>
      <a-select
        v-model:value="selectOption"
        class="w-[105px]"
        placeholder="无"
        size="middle"
        @change="onSelectOptionChange"
      >
        <a-select-option value="无">无</a-select-option>
        <!-- 预置表带选项 -->
        <a-select-option
          v-for="option in PRESET_SKU"
          :key="option.name"
          :value="option.url"
          class="relative"
          >{{ option.name }}
        </a-select-option>

        <a-select-option
          value=""
          disabled
          style="
            padding: 0px 12px;
            background: transparent;
            min-height: 25px;
            cursor: pointer;
          "
        >
          <div class="border-0 border-t-[1px] border-white opacity-20" />
        </a-select-option>
        <a-select-option
          v-for="option in options"
          :key="option.label"
          :value="option.value"
          class="relative"
        >
          <div class="flex items-center justify-between overflow-x-hidden">
            <div
              class="shrink truncate"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ option.label }}
            </div>
            <span>
              <a-tooltip title="删除">
                <icon
                  :icon="'subtract.svg'"
                  :width="15"
                  :height="15"
                  @click="onImageRemove(option.value, $event)"
                />
              </a-tooltip>
            </span>
          </div>
        </a-select-option>
        <template v-if="options.length">
          <a-select-option
            value=""
            disabled
            style="
              padding: 0px 12px;
              background: transparent;
              min-height: 25px;
              cursor: pointer;
            "
          >
            <div
              class="border-0 border-t-[1px] border-white opacity-20 bg-transparent"
            />
          </a-select-option>
        </template>
        <a-select-option value="添加" @click="onImageUpload()">
          <div class="flex items-center justify-between">
            <div class="">添加</div>
            <span>
              <a-tooltip title="添加">
                <icon :icon="'add.svg'" :width="14" :height="14" />
              </a-tooltip>
            </span>
          </div>
        </a-select-option>
        <template #suffixIcon>
          <span class="flex items-center">
            <icon icon="arrow-down3.svg" :width="14" :height="14" fill="none" />
          </span>
        </template>
      </a-select>
      <div class="opacity-70 text-xs ml-6 -mb-[2px] mt-1">表带与ID</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWatchfaceSku } from '@/hooks';
import { ref, computed, watch } from 'vue';
import { useEditorStore } from '@/store/use-editor-store';
import { useImagesStore } from '@/store/use-images-store';
import { ElectronApi } from '@/services/electron.api';
import { useWatchfaceStore } from '@/store/use-watchface-store';

const selectOption = ref();
const editorStore = useEditorStore();
const watchfaceStore = useWatchfaceStore();
const { uploadSkuImage, delSkuImage, loadPresetSku } = useWatchfaceSku();
const imageStore = useImagesStore();

const PRESET_SKU = ref<{ name: string; url: string }[]>([]);
watch(
  () => watchfaceStore.description.deviceType,
  async (deviceType) => {
    PRESET_SKU.value = await loadPresetSku(deviceType ?? '');
  },
  { immediate: true }
);

const options = computed(() => {
  const imgs = imageStore.skuArr;
  return [
    ...imgs.map((item) => {
      const path = ElectronApi.path?.basename(
        item.basename?.split('/')?.pop() ?? ''
      );
      return {
        label: path?.slice(0, path?.indexOf('.')),
        value: item.basename
      };
    })
  ];
});
const onImageUpload = async () => {
  let img = await uploadSkuImage();
  selectOption.value = img?.basename;
  onSelectOptionChange();
};
const onImageRemove = async (option: string, e: MouseEvent) => {
  e.stopPropagation();
  await delSkuImage(option);
  selectOption.value = '';
};
const onSelectOptionChange = () => {
  editorStore.$patch({
    sku: selectOption.value
  });
};
</script>

<style lang="less" scoped>
._grid {
  display: grid;
  grid-template-columns: 100px 20px;
  align-items: center;
}

._grid :deep(.ant-select-selector) > .ant-select-selection-item span {
  display: none;
}
:deep(.ant-select-selector) {
  border-radius: 4px !important;
  height: 30px !important;
  .ant-select-selection-item.ant-select-selection-item {
    bottom: 2.5px;
  }
  .ant-select-selection-placeholder.ant-select-selection-placeholder {
    position: relative;
    bottom: 2.5px;
  }
}
:deep(.ant-select-arrow) {
  right: 15px;
}
</style>
